"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ConsentPolicyCategories;
(function (ConsentPolicyCategories) {
    ConsentPolicyCategories["Essential"] = "essential";
    ConsentPolicyCategories["Functional"] = "functional";
    ConsentPolicyCategories["Analytics"] = "analytics";
})(ConsentPolicyCategories = exports.ConsentPolicyCategories || (exports.ConsentPolicyCategories = {}));
//# sourceMappingURL=types.js.map